import axios from '@/libs/api.request';

export const getPreSaleDeliveryRecord = data => {
    return axios.request({
        url: 'api/preSaleManagement/delivery/getAPPPreSaleDeliveryListByUuid',
        data: data,
        method: 'post'
    });
};

export const getPreSaleDeliveryDefaultDistributionStation = data => {
    return axios.request({
        url: 'api/preSaleManagement/delivery/getPreSaleDeliveryDefaultDistributionStation',
        data: data,
        method: 'post'
    });
};

export const updatePreSaleDeliveryShippedDistributionStation = data => {
    return axios.request({
        url: 'api/preSaleManagement/delivery/UpdatePreSaleDeliveryShippedDistributionStation',
        data: data,
        method: 'post'
    });
};

export const getPreSaleDeliveryRelateStationList = data => {
    return axios.request({
        url: 'api/saleManagement/shipping/getPreSaleDeliveryRelateStationList',
        data: data,
        method: 'post'
    });
};

export const UpdatePreSaleDelivery = data => {
    return axios.request({
        url: 'api/preSaleManagement/delivery/UpdatePreSaleDelivery',
        data: data,
        method: 'post'
    });
};



export const getPreSaleDeliveryList = data => {
    return axios.request({
        url: 'api/preSaleManagement/delivery/getPreSaleDeliveryList',
        data: data,
        method: 'post'
    });
};

export const getPreSaleDeliveryListOld = data => {
    return axios.request({
        url: 'api/preSaleManagement/delivery/getPreSaleDeliveryListOld',
        data: data,
        method: 'post'
    });
};

export const updatePreSaleDeliveryByUuid = data => {
    return axios.request({
        url: 'api/preSaleManagement/delivery/updatePreSaleDeliveryByUuid',
        data: data,
        method: 'post'
    });
};

export const SubmitPreSaleDelivery = data => {
    return axios.request({
        url: 'api/preSaleManagement/delivery/SubmitPreSaleDelivery',
        data: data,
        method: 'post'
    });
};

export const DeletePreSaleDelivery = data => {
    return axios.request({
        url: 'api/preSaleManagement/delivery/DeletePreSaleDelivery',
        data: data,
        method: 'post'
    });
};


export const closePreSaleDeliveryByUuid = data => {
    return axios.request({
        url: 'api/preSaleManagement/delivery/closePreSaleDeliveryByUuid',
        data: data,
        method: 'post'
    });
};

export const canclePreSaleDeliveryByUuid = data => {
    return axios.request({
        url: 'api/preSaleManagement/delivery/canclePreSaleDeliveryByUuid',
        data: data,
        method: 'post'
    });
};

export const updatePreSaleDeliveryDetailByUuid = data => {
    return axios.request({
        url: 'api/preSaleManagement/delivery/updatePreSaleDeliveryDetailByUuid',
        data: data,
        method: 'post'
    });
};

export const updatePreSaleDeliveryReceiveQuantity = data => {
    return axios.request({
        url: 'api/preSaleManagement/delivery/updatePreSaleDeliveryReceiveQuantity',
        data: data,
        method: 'post'
    });
};

export const confirmPreSaleDeliveryByUuid = data => {
    return axios.request({
        url: 'api/preSaleManagement/delivery/confirmPreSaleDelivery',
        data: data,
        method: 'post'
    });
};

export const printPreSaleDeliveryRecord = data => {
    return axios.request({
        url: 'api/preSaleManagement/delivery/printPreSaleDeliveryRecord',
        data: data,
        method: 'post'
    });
};

export const getPageShippingList = data => {
    return axios.request({
        url: 'web/saleManagement/shipping/getPageShippingList',
        data: data,
        method: 'post'
    });
};
//撤销发货
export const cancelPreSaleDeliveryByUuidIn24 = data => {
    return axios.request({
        url: 'api/preSaleManagement/delivery/cancelPreSaleDeliveryByUuidIn24',
        data: data,
        method: 'post'
    });
};

//返定金
export const depositBillOrderReturnDepositFee = data => {
    return axios.request({
        url: 'api/preSaleManagement/deposit/depositBillOrderReturnDepositFee',
        data: data,
        method: 'post'
    });
};